export enum TrendType {
  passing = 'PASSING',
  commercialSpeed = 'COMMERCIAL_SPEED',
  drillingCompleteWellsCount = 'DRILLING_COMPLETE_WELLS_COUNT',
  developmentCompleteWellsCount = 'DEVELOPMENT_COMPLETE_WELLS_COUNT',
}

export const isTrendType = (value: unknown): value is TrendType =>
  typeof value === 'string' && Object.values<string>(TrendType).includes(value);
